import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Divider, Typography } from "@mui/material";
import sampleExcelPath from "./InventorySample.xlsx";
import styles from "./Inventory.module.css";
import { MdOutlineFileUpload } from "react-icons/md";

const AssignInventoryModal = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      // onClose={handleClose}
      className={styles.assignContainer}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="modalThemeColor">
        <Typography variant="h6" component="div">
          Assign Inventory :
        </Typography>
      </DialogTitle>
      <Divider />
      <Typography
        variant="h6"
        component="div"
        gutterBottom
        sx={{ padding: "10px 24px!important" }}
      >
        Assign Inventory to client
      </Typography>

      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          Select Client <span style={{ color: "red" }}>*</span>
        </Typography>
        <Autocomplete
          size="small"
          options={[]} // Replace with your client options
          renderInput={(params) => <TextField {...params} variant="outlined" />}
          style={{ marginBottom: 16 }}
        />
        <Typography variant="subtitle1" gutterBottom>
          SIM Selection:{" "}
          <a href={sampleExcelPath} download className={styles.downloadLink}>
            ( Download Sample CSV)
          </a>
        </Typography>
        <div className={styles.fileInputContainer}>
          <input
            type="file"
            accept=".xlsx, .csv"
            size="small"
            id="file-upload"
            style={{ display: "none" }}
          />
          <label htmlFor="file-upload" className={styles.fileInputLabel}>
            <Typography
              variant="body1"
              component="span"
              className={styles.fileInputText}
            >
              No File Chosen
            </Typography>
          </label>
          <MdOutlineFileUpload className={styles.downloadIcon} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="error" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleClose} color="success" variant="contained">
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignInventoryModal;
